import { Alert, Box, Button, Container, FormControl, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Snackbar, Stack, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { useSelector,useDispatch } from 'react-redux';
import { ajoutsuccess,idretour,showapercu,modifsuccess,getvendeurs,getcamions } from "./RetourcamionSlice";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import Apercu from './Apercu';

export default function RetoursCamion() {

  const retourData = useSelector(state => state.retourscamionData);
  const ajoutSuccess = retourData.ajoutsuccess;
  const modifSuccess = retourData.modifsuccess;
  const ListVendeur = retourData.listVendeurs;
  const ListCamion = retourData.listCamions
  const [Chargement, setChargement] = useState(false);
  const [listretours, setListretours] = useState([]);
  const [removeSuccess, setRemoveSuccess] = useState(false);
  const [Progession, setProgession] = useState(false);
  const [valType, setvalType] = useState('Tout');
  const [ListProduits,setListProduits] = useState([]);
  const [valVendeurs, setvalVendeurs] = useState('Tout');
  const [valCamions, setvalCamions] = useState('Tout');

  const userData = useSelector(state => state.userData)
  const id = userData.id;
  const apitoken = userData.apitoken;
  const typeCompte = userData.type
  const apiUrl = process.env.REACT_APP_API_URL;
  const vendeurField = useRef('')
  const camionField = useRef('')


  const navigate = useNavigate();
  const dispatch= useDispatch();

  const handleTypeChange = (event) => {
    setvalType(event.target.value);
  };
  const handleVendeurChange = (event) => {
    setvalVendeurs(event.target.value);
    };
  
    const handleCamionsChange = (event) => {
      setvalCamions(event.target.value);
      };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(ajoutsuccess(false));
    dispatch(modifsuccess(false));
    setRemoveSuccess(false);
  };

  const formatDateToFrench = (dateString) => {
    const [date] = dateString.split('T');
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  };

  const modifier = (id) => {
    const filtreretour = listretours.filter(list => list._id === id);
    dispatch(idretour(filtreretour));
    navigate('/home/editretourcamion');
  }

  const suppression = async (idretour)=> {
    setProgession(true)
    
    try {
        const response = await axios.post(`${apiUrl}delete/retourcamion/${id}/${apitoken}/${idretour}`,
          {
            timeout: 20000,
          }
        );
        if(response.data.status==="ok")
            {
                const newlist=listretours.filter(achat => achat._id !== idretour);
                setListretours(newlist);
                setRemoveSuccess(true);
            }
    } catch (error) {
      navigate('/');
    }
    setProgession(false)
}

const supprimer = (id) => {
  let result = window.confirm(`Supprimer ce retour ?`);
  if (result === true) {
      suppression(id);
  }
}

const ShowApercu=async (list) => {
  setListProduits(list)
  dispatch(showapercu(true))
}



function ShowList() {
  if(listretours.length > 0){
    let listFiltre=listretours
    if(valType!=="Tout") {
      listFiltre = listFiltre.filter(retour => retour.type === valType)
  }
  if(valCamions!=="Tout") {
    listFiltre = listFiltre.filter(retour => retour.camion["id"] === valCamions)
}
if(valVendeurs!=="Tout") {
  listFiltre = listFiltre.filter(retour => retour.vendeur["id"] === valVendeurs)
}
    return listFiltre.map(Retour => {
      return(
        <StyledTableRow key={Retour._id}>
        <StyledTableCell component="th" scope="row">
          {Retour.type}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          {Retour.camion["designation"]}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          {Retour.vendeur["nom"]}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          {Retour.remarque}
        </StyledTableCell>

        <StyledTableCell component="th" scope="row">
        {Retour.date!=="" ? formatDateToFrench(Retour.date) : ''}
        </StyledTableCell>
        <StyledTableCell align="right">
        <Button variant="outlined" color='secondary' startIcon={<VisibilityIcon />} onClick={() => ShowApercu(Retour.produits)}>
        Aperçu
        </Button> 
        { typeCompte === "admin" ? 
        <>     
        <Button sx={{ marginLeft: '10px' }} variant="outlined" color='warning' startIcon={<EditIcon />} onClick={() => modifier(Retour._id)}>
         Modifier
        </Button> 
        <Button sx={{ marginLeft: '10px' }} variant="outlined" color='error' startIcon={<DeleteIcon />} onClick={() => supprimer(Retour._id)}>
         Supprimer
        </Button>
        </>
        :
        ""
    }
        </StyledTableCell>
      </StyledTableRow>
      )

    })
    }
    else {
      return (
        <StyledTableRow>
        <StyledTableCell align='center' colSpan={6} component="th" scope="row">
        Pas de données
        </StyledTableCell>
      </StyledTableRow>
      )
    }
    }

const GetRetours=async () => {
  setChargement(true)
    try {
    const response = await axios.post(`${apiUrl}retourcamion/${id}/${apitoken}`,
      {
        timeout: 20000,
      }
    );
    setListretours(response.data);
    }
  catch (error) {
    navigate('/');    
  }
  setChargement(false)
}


const Ajouter=() => {
  navigate('/home/nouveauretourcamion');
  }

  const getVendeurs=async () => {
    try {
    const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
      {
        timeout: 20000,
      }
    );
    dispatch(getvendeurs(response.data));
    }
 catch (error) {
  navigate('/');    
}
}
const getCamions=async () => {
  try {
  const response = await axios.post(`${apiUrl}camions/${id}/${apitoken}`,
    {
      timeout: 20000,
    }
  );
  dispatch(getcamions(response.data));
  }
catch (error) {
navigate('/');    
}
}
  useEffect(() =>{
    GetRetours();
    getVendeurs();
    getCamions();
    },[]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
    <Typography variant="h4" align='center' color="primary">
      Retours défectueux
        </Typography>

        <Box display="flex" width="100%" mt={5}>

<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={180} />
         :
<FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="demo-simple-select-label">Type retour</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valType}
          label="Type retour"
          onChange={handleTypeChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          <MenuItem value='Produits périmés'>Produits périmés</MenuItem>
          <MenuItem value='Produits dégradés'>Produits dégradés</MenuItem>

          </Select>
          </FormControl>
}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginLeft:2,marginTop: '20px' }}  variant="rounded" height={56} width={180} />
         :
         <FormControl sx={{ minWidth: 150,marginLeft:2 }}>
         <InputLabel id="demo-simple-select-label">Vendeurs</InputLabel>
         <Select
       
         labelId="demo-simple-select-label"
         id="vendeur"
         inputRef={vendeurField}
         value={valVendeurs}
         label="Vendeurs"
         onChange={handleVendeurChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
         {ListVendeur.map((item) => (
        <MenuItem key={item._id} value={item._id}>
          {item.nom}
        </MenuItem>
      ))}
         </Select>
         </FormControl>
  }
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginLeft:2,marginTop: '20px' }}  variant="rounded" height={56} width={180} />
         :
         <FormControl sx={{ minWidth: 150,marginLeft:2 }}>
         <InputLabel id="demo-simple-select-label">Camions</InputLabel>
         <Select
       
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         inputRef={camionField}
         value={valCamions}
         label="Camions"
         onChange={handleCamionsChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
         {ListCamion.map((item) => (
        <MenuItem key={item._id} value={item._id}>
          {item.designation}
        </MenuItem>
      ))}
         </Select>
         </FormControl>
}
</Box>

            <Box style={{ marginLeft: 'auto' }}>

               {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :

        <Button variant="contained" size='large' color="primary" startIcon={<AddIcon/>} onClick={Ajouter} >
    Nouveau Retour
  </Button>  
} 
</Box>
        </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
          <StyledTableCell>Type retour</StyledTableCell>
          <StyledTableCell>Camion</StyledTableCell>
          <StyledTableCell>Vendeur</StyledTableCell>
            <StyledTableCell>Remarque</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}

          <Snackbar open={ajoutSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Retour ajouté avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={modifSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Retour modifié avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Retour supprimé avec succès
        </Alert>
      </Snackbar>
      <Apercu Chargements={ListProduits} />
        </Container>
  )
}
